module.exports = __webpack_public_path__ + "assets/img/bottom-bg.c0081680.png";